/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const BIAXIAL_WIDGET_CLEAR_DATA = 'BIAXIAL_WIDGET_CLEAR_DATA';
export const BIAXIAL_WIDGET_UPDATE_CARET_VISIBLE = 'BIAXIAL_WIDGET_UPDATE_CARET_VISIBLE';
export const BIAXIAL_WIDGET_UPDATE_HORIZONTAL_ITEMS = 'BIAXIAL_WIDGET_UPDATE_HORIZONTAL_ITEMS';
export const BIAXIAL_WIDGET_UPDATE_HORIZONTAL_POSITION =
    'BIAXIAL_WIDGET_UPDATE_HORIZONTAL_POSITION';
export const BIAXIAL_WIDGET_UPDATE_TURBO_SCROLL = 'BIAXIAL_WIDGET_UPDATE_TURBO_SCROLL';
export const BIAXIAL_WIDGET_UPDATE_VERTICAL_ITEMS = 'BIAXIAL_WIDGET_UPDATE_VERTICAL_ITEMS';
export const BIAXIAL_WIDGET_UPDATE_VERTICAL_POSITION = 'BIAXIAL_WIDGET_UPDATE_VERTICAL_POSITION';
